import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './index.css';

const kok = document.getElementById('kok');
if (!kok) throw new Error('kok elementi bulunamadi');

createRoot(kok).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
